import type { ClientId, EditingUserJSON, UserId } from 'balus-common';
import type { UserPublicProfile } from '@user/PublicProfile';

type EditingUserAttributes = {
  userId: UserId;
  name: string;
  imageUrl: string | null;
  clientId: ClientId;
  isAnonymous: boolean;
};

export class EditingUser {
  public readonly userId: UserId;
  public readonly name: string;
  public readonly imageUrl: string | null;
  public readonly clientId: ClientId;
  public readonly isAnonymous: boolean;

  constructor(attributes: EditingUserAttributes) {
    this.userId = attributes.userId;
    this.name = attributes.name;
    this.imageUrl = attributes.imageUrl;
    this.clientId = attributes.clientId;
    this.isAnonymous = attributes.isAnonymous;
  }

  static buildFromProfile(profile: UserPublicProfile, clientId: ClientId): EditingUser {
    return new this({
      userId: profile.id,
      name: profile.name,
      imageUrl: profile.imageUrl,
      isAnonymous: profile.isAnonymous,
      clientId,
    });
  }

  isEqual(other: EditingUser): boolean {
    return (
      other instanceof EditingUser &&
      this.userId === other.userId &&
      this.name == other.name &&
      this.imageUrl == other.imageUrl &&
      this.clientId === other.clientId &&
      this.isAnonymous === other.isAnonymous
    );
  }

  dump(): EditingUserJSON {
    const { userId, name, imageUrl, clientId, isAnonymous } = this;

    return {
      userId,
      name,
      imageUrl,
      clientId,
      isAnonymous,
    };
  }

  static load(dump: EditingUserJSON): EditingUser {
    return new EditingUser({
      userId: dump.userId,
      name: dump.name,
      imageUrl: dump.imageUrl,
      clientId: dump.clientId,
      isAnonymous: dump.isAnonymous,
    });
  }
}
